import React, { useEffect } from "react";
import { useFormik } from "formik";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import ToggleSwitch from "../../lib/Common/ToggleSwitch";
import { deliveryAddressSchema } from "../../validations/schema";
import BackNextButtons from "../../lib/Common/BackNextButtons";
import { useTranslation } from "react-i18next";

const DeliveryAddressTab = ({
  formData,
  updateFormData,
  values,
  currentStep,
  setCurrentStep,
  showSave,
  backStep,
}) => {
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: formData?.deliveryAddress,
    validationSchema: deliveryAddressSchema,
    onSubmit: (values) => {
      updateFormData({
        ...formData,
        deliveryAddress: {
          ...formData?.deliveryAddress,
          ...values,
          deliv_address_addition: values?.deliv_address_addition
            ? values?.deliv_address_addition.trim()
            : "",
          bill_address_addition: values?.bill_address_addition
            ? values?.bill_address_addition.trim()
            : "",
        },
      });
    },
  });

  useEffect(() => {
    if (formik.values?.differentBillingAddress) {
      formik.setValues({
        ...formik.values,
        bill_address_addition: formik.values?.bill_address_addition || "",
        bill_address_city: formik.values?.bill_address_city || "",
        bill_address_house_number:
          formik.values?.bill_address_house_number || "",
        bill_address_street: formik.values?.bill_address_street || "",
        bill_address_zipcode: formik.values?.bill_address_zipcode || "",
        accounting_email: formik.values?.accounting_email || "",
      });
    } else {
      formik.setValues({
        ...formik.values,
        bill_address_addition: "",
        bill_address_city: "",
        bill_address_house_number: "",
        bill_address_street: "",
        bill_address_zipcode: "",
        accounting_email: "",
      });
    }
  }, [formik.values?.differentBillingAddress]);
  return (
    <div>
      <h2 className="fontSize32Regular lineHeight38 textgreen  mb-2 mb-md-5 heading-text">
        {t("Delivery Address")}
      </h2>

      <div className="row g-md-3 g-1 mb-1 ">
        <div className="col-12 col-md-8 col-lg-9">
          <TextInputFormik
            label={t("Street")}
            field="deliv_address_street"
            formik={formik}
            required
          />
        </div>
        <div className="col-12 col-md-4 col-lg-3">
          <TextInputFormik
            label={t("House Number")}
            field="deliv_address_house_number"
            formik={formik}
            max={5}
            required
          />
        </div>
      </div>

      <div className="mb-2 mb-md-4">
        <TextInputFormik
          label={t("Address Additional")}
          field="deliv_address_addition"
          formik={formik}
        />
      </div>

      <div className="row g-2 g-md-3 mb-2 mb-md-4">
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
          <TextInputFormik
            label={t("Postal Code")}
            field="deliv_address_zipcode"
            formik={formik}
            disable={true}
            required
          />
        </div>
        <div className="col-12 col-sm-6 col-md-8 col-lg-9">
          <TextInputFormik
            label={t("City")}
            field="deliv_address_city"
            formik={formik}
            required
          />
        </div>
      </div>

      <div className="mb-2 mb-md-5 fontSize14Medium lineHeight24 mt-1 mt-md-2">
        <ToggleSwitch
          label={t("Different billing address?")}
          checked={formik.values.differentBillingAddress}
          onChange={(checked) =>
            formik.setFieldValue("differentBillingAddress", checked)
          }
        />
      </div>

      {formik.values.differentBillingAddress && (
        <div className="mt-2 mt-md-4">
          <h3 className="fontSize32Regular lineHeight38 textgreen mb-2 mb-md-5 heading-text">
            {t("Billing Address")}
          </h3>

          <div className="row g-md-3 g-1 mb-1">
            <div className="col-12 col-md-8 col-lg-9">
              <TextInputFormik
                label={t("Street")}
                field="bill_address_street"
                formik={formik}
                required
              />
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <TextInputFormik
                label={t("House Number")}
                field="bill_address_house_number"
                formik={formik}
                max={5}
                required
              />
            </div>
          </div>

          <div className="mb-2 mb-md-4">
            <TextInputFormik
              label={t("Address Additional")}
              field="bill_address_addition"
              formik={formik}
            />
          </div>
          <div className="col-12 mb-2 mb-md-4">
            <TextInputFormik
              label={t("Accounting Email")}
              field="accounting_email"
              type="email"
              formik={formik}
              placeholder="e.g john.smith@companyemail.com"
            />
          </div>

          <div className="row g-2 g-md-3 mb-2 mb-md-4">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
              <TextInputFormik
                label={t("Postal Code")}
                field="bill_address_zipcode"
                formik={formik}
                max={5}
                required
              />
            </div>
            <div className="col-12 col-sm-6 col-md-8 col-lg-9">
              <TextInputFormik
                label={t("City")}
                field="bill_address_city"
                formik={formik}
                required
              />
            </div>
          </div>
        </div>
      )}

      <BackNextButtons
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onClick={async (nextStep) => {
          const errors = await formik.validateForm();
          formik.handleSubmit();
          if (Object.keys(errors).length == 0) {
            setCurrentStep(nextStep);
          }
        }}
        values={{ ...formData, deliveryAddress: formik.values, ...values }}
        backStep={backStep}
        showSave={showSave}
      />
    </div>
  );
};

export default DeliveryAddressTab;
